import { render, staticRenderFns } from "./VariaveisTab.vue?vue&type=template&id=51d06c82&"
import script from "./VariaveisTab.vue?vue&type=script&lang=js&"
export * from "./VariaveisTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports